export const TextContainerDivs = [
    {
        bgLink: "/backgrounds/home_2.png",
        mobileBg: '/backgrounds/mobile_home_2.png',
        title: "Chaos",
        subTitle:
            "A rare disaster, a pandemic, has resulted in a tragically large number of human lives being lost.",
        description:
            "As countries implement necessary quarantines and social distancing practices to contain the pandemic, the world has been put in a Lockdown. The magnitude and speed of collapse in activity that has followed is unlike anything experienced in our lifetimes.",
    },
    {
        bgLink: "/backgrounds/home_3.jpeg",
        mobileBg: '/backgrounds/mobile_home_3.png',
        title: "Enter the Purge",
        subTitle:
            "In 2022 the company Mediq brought a new medicine on the market to fight against the pandemic and save human lives, they said this would change the world.",
        description: "This definitely happened but in the worst way possible…",
    },
    {
        bgLink: "/backgrounds/home_4.jpeg",
        mobileBg: '/backgrounds/mobile_home_4.png',
        title: "Near Future",
        subTitle:
            "Purge Town takes place in a near-future world where a company called Mediq has taken control of the world.",
        description:
            "Almost 99% of the citizens took the medicine and became very sick. After a few months the whole world turned into a ghost town. People started looting shops and killing each other…",
    },

    {
        bgLink: "/backgrounds/home_5.png",
        mobileBg: '/backgrounds/mobile_home_5.png',
        title: "Freedom",
        subTitle: "Paul is ready to purge, are you?",
        description:
            "Only a few people who didn't believe Mediq refused the medicine and are now fighting against the zombies. Paul was a military man for years but now needs to protect his family!",
        inverted: true,
    },
];